// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".forgot-password{padding:183px 0 0}.forgot-password .logo-evangelus{margin-top:40px;margin-bottom:60px;margin-left:0;margin-right:0}.input-eva-border-bottom.input-eva-phone-email-icon{margin-bottom:70px;background-position:12% center}\n", ""]);
// Exports
module.exports = exports;
